import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from '../pages/auth/LoginPage';
import DashboardLayout from '../layouts/DashboardLayout';
import DashboardPage from '../pages/DashboardPage';
import SchoolsPage from '../pages/SchoolsPage';
import SchoolDetailPage from '../pages/SchoolDetailPage';
import NotificationsPage from '../pages/NotificationsPage';
import ImportantNoticesPage from '../pages/ImportantNoticesPage';
import StripePage from '../pages/StripePage';
import UsersPage from '../pages/UsersPage';
import FAQsPage from '../pages/FAQsPage';
import FAQEditPage from '../pages/FAQEditPage';
import FAQCategoriesPage from '../pages/FAQCategoriesPage';
import NotificationEditPage from '../pages/NotificationEditPage';
import ImportantNoticeEditPage from '../pages/ImportantNoticeEditPage';
import MediaLibraryPage from '../pages/MediaLibraryPage';
import FeedbacksPage from '../pages/FeedbacksPage';
import FeedbackDetailPage from '../pages/FeedbackDetailPage';
import LoadingScreen from '../components/LoadingScreen';
import AuthActionHandler from '../pages/AuthActionHandler';
import ContentManagementPage from '../pages/ContentManagementPage';
import PolicyEditPage from '../pages/PolicyEditPage';
import InquiriesPage from '../pages/InquiriesPage';
import InquiryDetailPage from '../pages/InquiryDetailPage';

export default function RootRouter() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {/* 認証不要でアクセス可能なメールアクションハンドラ */}
      <Route path="/auth-action" element={<AuthActionHandler />} />
      {user ? (
        <>
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="schools" element={<SchoolsPage />} />
            <Route path="schools/:id" element={<SchoolDetailPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="notifications/new" element={<NotificationEditPage />} />
            <Route path="notifications/:id/edit" element={<NotificationEditPage />} />
            <Route path="important-notices" element={<ImportantNoticesPage />} />
            <Route path="important-notices/new" element={<ImportantNoticeEditPage />} />
            <Route path="important-notices/:id/edit" element={<ImportantNoticeEditPage />} />
            <Route path="content" element={<ContentManagementPage />} />
            <Route path="content/:type" element={<PolicyEditPage />} />
            <Route path="stripe" element={<StripePage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="faqs" element={<FAQsPage />} />
            <Route path="faq-categories" element={<FAQCategoriesPage />} />
            <Route path="faqs/new" element={<FAQEditPage />} />
            <Route path="faqs/:id/edit" element={<FAQEditPage />} />
            <Route path="media-library" element={<MediaLibraryPage />} />
            <Route path="feedbacks" element={<FeedbacksPage />} />
            <Route path="feedbacks/:id" element={<FeedbackDetailPage />} />
            <Route path="inquiries" element={<InquiriesPage />} />
            <Route path="inquiries/:id" element={<InquiryDetailPage />} />
          </Route>
        </>
      ) : (
        <>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      )}
    </Routes>
  );
}